import { render, staticRenderFns } from "./NewsSingle.vue?vue&type=template&id=649ba6e0&scoped=true"
import script from "./NewsSingle.vue?vue&type=script&lang=js"
export * from "./NewsSingle.vue?vue&type=script&lang=js"
import style0 from "./NewsSingle.vue?vue&type=style&index=0&id=649ba6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649ba6e0",
  null
  
)

export default component.exports